<template>
  <div class="bg-gray">
    <transition name="fade">
      <v-progress-linear
        v-if="isLoading"
        color="accent"
        class="pa-0 ma-0"
        height="3"
        indeterminate
      />
    </transition>
  </div>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'

export default {
  name: 'CheckLinkPage',
  computed: {
    documentURL () {
      return this.$route.query && this.$route.query.document
        ? this.$route.query.document
        : null
    },

    routeQueryParams () {
      return this.$route.query
    },

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      currentStatus: STATUS_IS_LOADING
    }
  },

  methods: {
    sleep () {
      return new Promise((resolve) => {
        setTimeout(() => resolve(), 1000)
      })
    },

    createHideLink (documentURL) {
      const $a = document.createElement('a')
      $a.href = documentURL
      $a.download = true
      document.body.appendChild($a)
      $a.click()
      $a.remove()
    },

    redirectToRoute (name) {
      this.$router.push({ name }).catch(() => {})
    },

    async downloadDocuments () {
      const url = `${process.env.VUE_APP_API_URL}b2b-document-app/download`
      const { document, token } = this.routeQueryParams
      const config = {
        method: 'GET',
        headers: { 'Authorization': token }
      }

      const res = await fetch(`${url}?document=${document}`, config)
      return res.json()
    },

    async getS3LinkDocument () {
      this.currentStatus = STATUS_IS_LOADING

      try {
        const res = await this.downloadDocuments()

        if (!res.valid) {
          return this.redirectToRoute('ExpiredLink')
        }

        this.createHideLink(res.content)
        this.currentStatus = STATUS_SUCCESS

        window.setTimeout(() => {
          this.redirectToRoute('Home')
        }, 1000)
      } catch (error) {
        console.log('ERROR:', error)
        this.redirectToRoute('ExpiredLink')
        this.currentStatus = STATUS_FAILED
      }
    }
  },
  mounted () {
    this.getS3LinkDocument()
  }
}
</script>
